import { Stack, Tooltip, Typography } from "@mui/material";
import React from "react";
import AvatarProfilePicture from "../../Misc/AvatarProfilePicture/avatar-profile-picture";

export interface TableCellNameProps {
  data: { value: { firstname: string; lastname: string; id?: number } };
}

const TableCellName: React.FC<TableCellNameProps> = ({ data }) => {
  return (
    <Stack direction="row" spacing={1.5} maxWidth={"100%"}>
      <AvatarProfilePicture
        size={32}
        userId={data.value.id!}
        userFirstName={data.value.firstname}
        userLastName={data.value.lastname}
      />
      <Stack flexShrink={1} overflow={"hidden"}>
        <Tooltip title={`${data.value.firstname} ${data.value.lastname}`}>
          <Typography fontWeight={500} sx={(theme) => ({ ...theme.helpers(theme).ellipsis })}>
            {data.value.firstname} {data.value.lastname}
          </Typography>
        </Tooltip>
        {data.value.id && (
          <Typography color="text.secondary" variant="body2" sx={(theme) => ({ ...theme.helpers(theme).ellipsis })}>
            #{data.value.id}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};

export default TableCellName;
